import { FC } from 'react';
import { PriceRecord } from '@/components/houses/_types/productItem.types';
import Typography from '@/components/UI/typography/Typography';
interface MidtermDiscountProps {
  pricing?: PriceRecord;
}
const MidtermDiscount: FC<MidtermDiscountProps> = ({
  pricing
}) => {
  return <Typography component="p" variant="bodyM" color="neutral_500" data-sentry-element="Typography" data-sentry-component="MidtermDiscount" data-sentry-source-file="MidtermDiscount.tsx">
      {Math.floor((Number(pricing?.total_monthly_price_without_discount?.amount) - Number(pricing?.total_monthly_price?.amount)) / Number(pricing?.total_monthly_price_without_discount?.amount) * 100)}
      %
    </Typography>;
};
export default MidtermDiscount;